import { render, staticRenderFns } from "./CoursewareToBereviewed.vue?vue&type=template&id=5765d8d7"
import script from "./CoursewareToBereviewed.vue?vue&type=script&lang=js"
export * from "./CoursewareToBereviewed.vue?vue&type=script&lang=js"
import style0 from "./CoursewareToBereviewed.vue?vue&type=style&index=0&id=5765d8d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports